import React from 'react'

const LogoWithText = () => {
    return (
        <h4 className='app_text_20_bold text-white mb-0'>
            Binox Bargains ( Vendor )
        </h4>

    )
}

export default LogoWithText